import React, { useState, useEffect } from 'react';
import { POPUP_KEY_ADD_PROPERTY } from '../../../constant';
import Modal from '../../Modal';
import { MODAL_SMALL_SIZE } from '../../helper';
import { propertiesStorage } from '../../../services/propertiesStorage';
import { productSaveService } from '../../../services/productSaveService';
import { propertyNamesService } from '../../../services/propertyNamesService';
import { useTranslation } from 'react-i18next';
import SelectWithoutTokens from '../../../shared/SelectWithoutTokens';
import { popupOpenService } from '../../../services/popupOpenService';
import { Button } from '@chapche/ui';

const createFilteredList = (fullPropertiesList, productProperties) => {
    return fullPropertiesList.filter(it => productProperties.findIndex(item => item.propertyName === it.propertyName) === -1);
};

const transformPropertiesListToSearchValueList = (properties, i18n) => {
    return properties.map((item) => {
        return {
            name: propertyNamesService.getLocalization(i18n.resolvedLanguage, item, true, i18n),
            code: item.propertyName,
            id: item.id,
        };
    });
};

const CreateNewPropertyModal = ({ handleClose, newPropertyCode, setNewPropertyCode, handleCreateNewProperty, propertiesEnumList }) => {
    const { i18n } = useTranslation();
    const propertiesList = transformPropertiesListToSearchValueList(propertiesEnumList, i18n);

    return (
        <div>
            <h2 className="modal__title block__title-h3 product__modal-title">{i18n.t(`app.page.product.productAddProperty.title`)}</h2>
            <label className="block__text product__form-label product__modal-property product__modal-label">
                <SelectWithoutTokens
                    listOfOptions={propertiesList}
                    handleChangeValue={(item) => setNewPropertyCode(item.name)}
                    titleValue={newPropertyCode}
                />
            </label>
            <div className="modal__button-group">
                <Button variant="outline" onClick={handleClose}>
                    {i18n.t(`app.page.product.productAddProperty.cancel`)}
                </Button>
                <Button disabled={!newPropertyCode} onClick={handleCreateNewProperty}>
                    {i18n.t(`app.page.product.productAddProperty.continue`)}
                </Button>
            </div>
        </div>
    );
};

const AddPropertyPopup = () => {
    const { i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState('');
    const [newPropertyCode, setNewPropertyCode] = useState('');

    const changePopupVisibility = () => {
        setIsVisible(true);
    };

    const handleCreateNewProperty = () => {
        const resultArray = transformPropertiesListToSearchValueList(propertiesStorage.getItems(true), i18n);
        const item = resultArray.find(it => it.name === newPropertyCode);
        productSaveService.addProductProperty(item.code, item.id);
        setIsVisible(false);
        setNewPropertyCode('');
    };

    const closePopup = () => {
        setIsVisible(false);
        setNewPropertyCode('');
    };

    useEffect(() => {
        popupOpenService.registerPopup(POPUP_KEY_ADD_PROPERTY, changePopupVisibility);
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_ADD_PROPERTY, changePopupVisibility);
    }, []);

    return (
        isVisible ?
            <Modal
                handleCloseModal={setIsVisible}
                size={MODAL_SMALL_SIZE}
                content={<CreateNewPropertyModal
                    handleCreateNewProperty={handleCreateNewProperty}
                    setNewPropertyCode={setNewPropertyCode}
                    handleClose={closePopup}
                    newPropertyCode={newPropertyCode}
                    propertiesEnumList={createFilteredList(propertiesStorage.getItems(true), Object.values(productSaveService.getProduct().properties))}
                />}
            />
            :
            null
    );
};

export default AddPropertyPopup;
